export default function handlerAddSourceInCopyText (evt, path: string) {
  const punycode = require('punycode/')

  evt.clipboardData.setData('text/plain', document.getSelection() + `\n\nИсточник - портал ${punycode.toUnicode(location.origin)}.\nПодробнее: ${punycode.toUnicode(location.origin) + path}`)
  evt.preventDefault()
}
